export const desformatarCPFCNPJ = (valor: string): string => {
    return valor.replace(/\D/g, '');
}

export const desformatarValorMonetario = (valor: string): number => {
    const apenasNumeros = valor.replace(/[^\d,]/g, '').replace(',', '.');
    return parseFloat(apenasNumeros);
}

export const desformatarTelefone = (valor: string): string => {
    return valor.replace(/\D/g, '');
}

export const desformatarCEP = (cep: string): string => {
    return cep.replace(/\D/g, '');
};